import { Link } from "react-router-dom";
import "../blocks/Header.css";
import header_png from "../images/header_png.png";
import header_mobilePng from "../images/header_mobile-png.png";
import header_mobileDecoration from "../images/header_mobile-decoration.png";
import header_decoration from "../images/header_decoration.png";

function Header() {
  return (
    <header className="header">
      <div className="header__cont">
        <img
          className="header__image"
          draggable="false"
          src={header_png}
          alt="ian_zubkov"
        />
        <img
          className="header__mobile-image"
          draggable="false"
          src={header_mobilePng}
          alt="ian_zubkov"
        />
        <div className="header__text-cont">
          <div className="header__first-cont">
            <p className="header__age">18+</p>
            <h1 className="header__name">Ян Зубков</h1>
          </div>
          <h2 className="header__text">стендап-комик</h2>
          <div className="header__mid-cont">
            <img
              className="header__decoration"
              src={header_decoration}
              draggable="false"
              alt="||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||"
            />
            <h3 className="header__description">
              {"[standup club #1, Токсики, labelcom roast battle]"}
            </h3>
            <div className="header__mobile-cont">
              <img
                className="header__mobile-decoration"
                src={header_mobileDecoration}
                draggable="false"
                alt="||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||"
              />
              <p className="header__mobile-age">
                ---------------- 18+ ---------------
              </p>
              <img
                className="header__mobile-decoration"
                src={header_mobileDecoration}
                draggable="false"
                alt="||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||"
              />
              <div className="header__link-cont">
                <Link
                  className="header__mobile-link"
                  to="https://www.youtube.com/@YanZubkovStandUp"
                  target="_blank"
                >
                  {"--> ютуб <--"}
                </Link>
                <Link
                  className="header__mobile-link"
                  to="https://t.me/yan_zubkov"
                  target="_blank"
                >
                  {"-> телеграм <-"}
                </Link>
                <Link
                  className="header__mobile-link"
                  to="https://www.instagram.com/zubkov_yan/"
                  target="_blank"
                >
                  {"--> Инста <--"}
                </Link>
                <Link
                  className="header__mobile-link"
                  to="https://boosty.to/ianzubkov"
                  target="_blank"
                >
                  {"--> Бусти <--"}
                </Link>
              </div>
            </div>
          </div>
          <Link
            className="header__link"
            to="https://www.youtube.com/@YanZubkovStandUp"
            target="_blank"
          >
            <p className="header__link-text">
              {"---------------> ютуб <--------------"}
            </p>
          </Link>
          <Link
            className="header__link"
            to="https://t.me/yan_zubkov"
            target="_blank"
          >
            <p className="header__link-text">
              {"---------------> Телеграм <---------"}
            </p>
          </Link>
          <Link
            className="header__link"
            to="https://www.instagram.com/zubkov_yan/"
            target="_blank"
          >
            <p className="header__link-text">
              {"---------------> Инст <--------------"}
            </p>
          </Link>
          <Link
            className="header__link"
            to="https://boosty.to/ianzubkov"
            target="_blank"
          >
            <p className="header__link-text">
              {"---------------> Бусти <--------------"}
            </p>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
